<template>
  <b-modal id="BranchRoleInfo" scrollable size="lg" centered hide-footer>
    <template #modal-title>
      <h3>
        <img src="@/assets/images/branch-roles.svg" class="icon-lg" />
        {{ $t("setting.others.branchRolesMsgs.data") }}
      </h3>
    </template>
    <div class="row">
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="branchRoleData.branchRoleNameAr"
        :title="$t('setting.others.branchRolesMsgs.nameAr')"
        :imgName="'branch-roles.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="branchRoleData.branchRoleNameEn"
        :title="$t('setting.others.branchRolesMsgs.nameEn')"
        :imgName="'branch-roles.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-12'"
        :value="branchRoleData.branchRoleNameUnd"
        :title="$t('setting.others.branchRolesMsgs.nameUnd')"
        :imgName="'branch-roles.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="branchRoleData.branchRoleDescriptionAr"
        :title="$t('setting.others.branchRolesMsgs.descriptionAr')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="branchRoleData.branchRoleDescriptionEn"
        :title="$t('setting.others.branchRolesMsgs.descriptionEn')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="branchRoleData.branchRoleDescriptionUnd"
        :title="$t('setting.others.branchRolesMsgs.descriptionUnd')"
        :imgName="'description.svg'"
      />

      <DataLabelGroup
        :className="'col-lg-6'"
        :value="branchRoleData.branchRoleNotes"
        :title="$t('notes')"
        :imgName="'notes.svg'"
      />
    </div>
  </b-modal>
</template>

<script>
import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import { setDataMultiLang, timeToLang } from "@/utils/functions";

export default {
  name: "BranchRoleInfo",
  components: {
    DataLabelGroup,
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["branchRoleData"],
  methods: {
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      return setDataMultiLang(lang, dataAr, dataEn);
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
